/**
 * Resolve module / subsection labels from i18n nameKey only.
 * Never falls back to the French `name` field in moduleStructure.
 */

export function resolveModuleNameKey(module) {
  if (module?.nameKey) {
    return module.nameKey;
  }
  if (module?.key) {
    return `modules.${module.key.toLowerCase()}.name`;
  }
  return null;
}

export function resolveModuleManagementTitleKey(module) {
  if (module?.managementTitleKey) {
    return module.managementTitleKey;
  }
  if (module?.key) {
    return `modules.${module.key.toLowerCase()}.management_title`;
  }
  return null;
}

export function getModuleLabel(module, t) {
  const nameKey = resolveModuleNameKey(module);
  if (nameKey) {
    return t(nameKey);
  }
  return '';
}

export function getSubsectionLabel(subsection, t) {
  if (subsection?.nameKey) {
    return t(subsection.nameKey);
  }
  return '';
}

export function getModuleManagementTitle(module, t) {
  const titleKey = resolveModuleManagementTitleKey(module);
  if (titleKey) {
    const translated = t(titleKey);
    if (translated && translated !== titleKey) {
      return translated;
    }
  }
  const moduleLabel = getModuleLabel(module, t);
  if (moduleLabel) {
    return `${t('common.management')} ${moduleLabel}`;
  }
  return '';
}
